module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp7-e5606dc364bbaeb9c29f8d6181f223be.jpg";